import { wrapCollectionLayout, EagerLoadImages } from "@quintype/components";
import React from "react";
import FourStoryHalfFeatured from "../rows/fourStoryHalfFeatured";
import NineStories from "../rows/nineStories";
import FiveOpinionStories from "../rows/fiveOpinionStories";
import FourStories from "../rows/fourStories";
import FourteenStories3Ad1Widget from "../rows/fourteenStories3Ad1Widget";
import FourCollection12Stories1Ad from "../rows/fourCollection12Stories1Ad";
import FourCollection12Stories from "../rows/fourCollection12Stories";
import SixStories1AdWithTagSearch from "../rows/sixStories1AdWithTagSearch";
import SixStories1WidgetWithPoll from "../rows/sixStories1WidgetWithPoll";
import TenStories2AdWithLoadMore from "../rows/tenStories2AdWithLoadMore";
import SixteenStories3AdWithTagSearchAndLoadMore from "../rows/sixteenStories3AdWithTagSearchAndLoadMore";
import SixteenStories1WidgetWithPollAndLoadMore from "../rows/sixteenStories1WidgetWithPollAndLoadMore";
import FiveVideoStories from "../rows/fiveVideoStories";
import BigPhotoStoryCardSlider1Ad from "../rows/bigPhotoStoryCardSlider1Ad";
import BigVideoStoryCard2Ad from "../rows/bigVideoStoryCard2Ad";
import FourColStoriesWithLoadMore from "../rows/fourColStoriesWithLoadMore";
import FourStoryCards from "../rows/fourStoryCards";
import FourteenStories2AdBigFact from "../rows/fourteenStories2AdBigFact";
import SliderFocusedCard from "../rows/sliderFocusedCard";
import PhotoStoryWithSlider from "../rows/photoStoryWithSlider";
import OneColThreeStoriesSlider from "../rows/OneColThreeStoriesSlider";
import TwelveStoryOneAdsOneWidget from "../rows/TwelveStoryOneAdsOneWidget";

// This should not be needed anymore as we are using Gumlet
function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    return (
      <EagerLoadImages predicate={token => token === "above-fold"}>{React.createElement(f, props)}</EagerLoadImages>
    );
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  return wrappedComponent;
}

export default {
  FourStoryHalfFeatured: wrapEager(wrapCollectionLayout(FourStoryHalfFeatured)),
  NineStories: wrapEager(wrapCollectionLayout(NineStories)),
  FiveOpinionStories: wrapEager(wrapCollectionLayout(FiveOpinionStories)),
  FourStories: wrapEager(wrapCollectionLayout(FourStories)),
  FourteenStories3Ad1Widget: wrapEager(wrapCollectionLayout(FourteenStories3Ad1Widget)),
  FourCollection12Stories1Ad: wrapEager(wrapCollectionLayout(FourCollection12Stories1Ad)),
  FourCollection12Stories: wrapEager(wrapCollectionLayout(FourCollection12Stories)),
  SixStories1AdWithTagSearch: wrapEager(wrapCollectionLayout(SixStories1AdWithTagSearch)),
  SixStories1WidgetWithPoll: wrapEager(wrapCollectionLayout(SixStories1WidgetWithPoll)),
  TenStories2AdWithLoadMore: wrapEager(wrapCollectionLayout(TenStories2AdWithLoadMore)),
  SixteenStories3AdWithTagSearchAndLoadMore: wrapEager(wrapCollectionLayout(SixteenStories3AdWithTagSearchAndLoadMore)),
  SixteenStories1WidgetWithPollAndLoadMore: wrapEager(wrapCollectionLayout(SixteenStories1WidgetWithPollAndLoadMore)),
  FiveVideoStories: wrapEager(wrapCollectionLayout(FiveVideoStories)),
  BigPhotoStoryCardSlider1Ad: wrapEager(wrapCollectionLayout(BigPhotoStoryCardSlider1Ad)),
  BigVideoStoryCard2Ad: wrapEager(wrapCollectionLayout(BigVideoStoryCard2Ad)),
  FourColStoriesWithLoadMore: wrapEager(wrapCollectionLayout(FourColStoriesWithLoadMore)),
  FourStoryCards: wrapEager(wrapCollectionLayout(FourStoryCards)),
  SliderFocusedCard: wrapEager(wrapCollectionLayout(SliderFocusedCard)),
  PhotoStoryWithSlider: wrapEager(wrapCollectionLayout(PhotoStoryWithSlider)),
  FourteenStories2AdBigFact: wrapEager(wrapCollectionLayout(FourteenStories2AdBigFact)),
  OneColThreeStoriesSlider: wrapEager(wrapCollectionLayout(OneColThreeStoriesSlider)),
  TwelveStoryOneAdsOneWidget: wrapEager(wrapCollectionLayout(TwelveStoryOneAdsOneWidget)),
  defaultTemplate: wrapEager(wrapCollectionLayout(FourColStoriesWithLoadMore))
};
